import type { ColourVariant } from '@weareopenr/component-library';
import type { IInvoice, InvoiceStatus } from '../../types';

export const INVOICE_STATUS_COLOUR: Record<InvoiceStatus, ColourVariant> = {
  draft: 'liquorice',
  issued: 'honey',
  sent: 'honey',
  paid: 'kale',
  void: 'grape',
};

export const INVOICE_STATUS_LABEL: Record<InvoiceStatus, string> = {
  draft: 'Draft',
  issued: 'Issued',
  sent: 'Sent',
  paid: 'Paid',
  void: 'Void',
};

export const statusLabel = (invoice: Pick<IInvoice, 'status' | 'overdue'>): string =>
  invoice.overdue ? 'Overdue' : INVOICE_STATUS_LABEL[invoice.status];

export const statusColour = (invoice: Pick<IInvoice, 'status' | 'overdue'>): ColourVariant =>
  invoice.overdue ? 'tomato' : INVOICE_STATUS_COLOUR[invoice.status];

/** YYYY-MM-DD to d/m/yy, the way the printed invoice shows dates. */
export const shortDate = (iso: string | null): string => {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${Number(d)}/${Number(m)}/${y.slice(2)}`;
};

export const longDate = (iso: string | null): string =>
  iso
    ? new Date(`${iso}T00:00:00Z`).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC',
      })
    : '—';

export const fmtMoney = (value: number, currency = 'GBP'): string =>
  `${currency === 'GBP' ? '£' : `${currency} `}${value.toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const isoToday = (): string => new Date().toISOString().slice(0, 10);

export const CYCLE_LABEL = {
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  annual: 'Annual',
} as const;
export const TIMING_LABEL = { advance: 'In advance', arrears: 'In arrears' } as const;
